import FeedBackPage from './FeedBackPage';
export default FeedBackPage;
